import IsiMusiman from "./src/IsiMusiman";

export default IsiMusiman;